Ext.define('SA.model.createimport.ColumnStepErrorList', {
    constructor({hasOneFile}) {
        this.hasOneFile = hasOneFile;

        this.errors = [];
    },

    addError(error) {
        this.errors.push(error);
    },

    addTplError(type, {tplData}) {
        var tpl = this.getError(type);

        this.addError(tpl.apply(tplData));
    },

    getError(type) {
        var error = SA.model.createimport.ColumnStepErrors[type];

        if (typeof error === 'string') {
            return error;
        }

        return this.hasOneFile ? error.ONE_FILE : error.MULTI_FILE;
    },

    maybeAddError(type, condition) {
        if (condition) {
            this.addError(this.getError(type));
        }
    },

    toArray() {
        return this.errors;
    }
});